const LibraryIcon = () => {
  return (
    <svg viewBox="0 0 22 18">
      <path d="M11 3.2C9.4 2.2 7.5 1.6 5.4 1.6c-1.5 0-2.9.3-4.2.9A1.2 1.2 0 0 0 0 3.6v11.1c0 .9.9 1.5 1.7 1.2 1.1-.4 2.3-.6 3.7-.6 1.7 0 3.2.4 4.6 1.1.5.3 1.2.3 1.7 0 1.4-.7 2.9-1.1 4.6-1.1 1.4 0 2.6.2 3.7.6.8.3 1.7-.3 1.7-1.2V3.6c0-.8-.5-1.4-1.2-1.1-1.3-.6-2.7-.9-4.2-.9-2.1 0-4 .6-5.6 1.6zm0 1.8c1.5-.9 3.2-1.4 5.1-1.4 1.2 0 2.3.2 3.3.6v9.7c-1-.3-2.1-.4-3.3-.4-1.9 0-3.6.5-5.1 1.4V5zm0 0C9.5 4.1 7.8 3.6 5.9 3.6c-1.2 0-2.3.2-3.3.6v9.7c1-.3 2.1-.4 3.3-.4 1.9 0 3.6.5 5.1 1.4V5z" />
    </svg>
  );
};

export default LibraryIcon;